import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ThemeService } from '../services/theme.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit {
  collapsed = signal(true);

  menuItems: {icon: string; label: string; route: string; adminOnly?: boolean}[] = [
    // Dashboard temporariamente oculto do menu (ver app.routes.ts).
    { icon: 'receipt_long', label: 'Inventários', route: '/inventory-list' },
    { icon: 'calendar_month', label: 'Bloqueios', route: '/calendar-config' },
    { icon: 'admin_panel_settings', label: 'Permissões', route: '/group-management' },
    { icon: 'manage_accounts', label: 'Usuários', route: '/users', adminOnly: true },
  ];

  constructor(public themeService: ThemeService, public authService: AuthService) {}

  get visibleMenuItems() { return this.menuItems.filter(item => !item.adminOnly || this.authService.isAdmin()); }

  ngOnInit() {
    // Configura a largura inicial do CSS da sidebar com base no estado collapsed
    document.documentElement.style.setProperty(
      '--sidebar-width',
      this.collapsed() ? 'var(--sidebar-collapsed)' : '260px'
    );
  }

  toggleCollapse() {
    this.collapsed.update(val => !val);
    // Atualiza a variável CSS global para que o container da aplicação acompanhe a largura
    document.documentElement.style.setProperty(
      '--sidebar-width',
      this.collapsed() ? 'var(--sidebar-collapsed)' : '260px'
    );
  }

  logout() {
    this.authService.logout();
  }
}
